<!--
 * @Descripttion: 场景管理主页（IAS 分角色）
 * @Date: 2026-07-24
-->
<template>
  <div class="scene-mgmt-main">
    <BaseTabs v-model="activeTab" class="scene-mgmt-tabs">
      <BaseTabPane
        v-for="tab in visibleTabs"
        :key="tab.name"
        :label="tab.label"
        :name="tab.name"
      />
    </BaseTabs>
    <div class="scene-mgmt-main__content">
      <component :is="activeComponent" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { BaseTabs, BaseTabPane } from 'xrk-components';
import IPriceList from '../components/i-price-list.vue';
import APlanList from '../components/a-plan-list.vue';

const route = useRoute();
const functionCode = computed(() => Number(route.meta.functionCode) || 1);

const ALL_TABS = [
  { name: 'industry', label: '工业场景库', component: IPriceList, roles: [1] },
  {
    name: 'provider',
    label: '服务商场景策划',
    component: APlanList,
    roles: [2]
  }
];

const visibleTabs = computed(() =>
  ALL_TABS.filter(tab => tab.roles.includes(functionCode.value))
);

const activeTab = ref(visibleTabs.value[0]?.name || 'industry');

// 角色切换时重置 activeTab 到当前角色第一个可见 Tab
watch(functionCode, () => {
  activeTab.value = visibleTabs.value[0]?.name || 'industry';
});

const TAB_COMPONENT_MAP: Record<string, any> = Object.fromEntries(
  ALL_TABS.map(tab => [tab.name, tab.component])
);

const activeComponent = computed(() => TAB_COMPONENT_MAP[activeTab.value]);
</script>

<style lang="scss" scoped></style>
